export function initAutoForm() {
  const blockButtons = document.querySelector('.js-filter-form-buttons')
  const buttonShow = blockButtons?.querySelector('.js-filter-form-toggle')
  const fields = document.querySelectorAll('.js-filter-form-hide')
  const buttonReset = document.querySelector('.js-filter-reset')

  if (buttonShow && fields) {
    buttonShow.addEventListener('click', () => {
      fields.forEach(item => {
        if (item.classList.contains('field-hide')) {
          item.classList.remove('field-hide')
          buttonReset.classList.remove('field-hide')
          blockButtons.classList.add('opened')
          buttonShow.innerHTML = 'Скрыть расширенный поиск'
          buttonShow.classList.add('arrow-up')
          buttonShow.classList.remove('arrow-down')
        } else {
          item.classList.add('field-hide')
          buttonReset.classList.add('field-hide')
          blockButtons.classList.remove('opened')
          buttonShow.innerHTML = 'Расширенный поиск'
          buttonShow.classList.add('arrow-down')
          buttonShow.classList.remove('arrow-up')
        }
      })
    })
  }
}
